import * as React from "react";
import { Avatar, Tooltip } from "@/components/ui";
import { ActorRef } from "@/services/bedrock/dtos/DesignPackage";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

interface PresenceAvatarsProps {
  viewers: ActorRef[];
  max?: number;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

/** Everyone else who has this design open. */
export const PresenceAvatars: React.FC<PresenceAvatarsProps> = ({ viewers, max = 4 }) => {
  const { userId } = useSocialCoachSession();
  const others = viewers.filter(viewer => Number(viewer.userId) !== Number(userId));
  if (others.length === 0) return null;

  const shown = others.slice(0, max);
  const overflow = others.length - shown.length;

  return (
    <Tooltip>
      <Tooltip.Trigger render={<span className="inline-flex" data-testid="presence-avatars" />}>
        <Avatar.Group>
          {shown.map(viewer => (
            <Avatar key={viewer.userId} size="sm">
              {viewer.avatarUrl && <Avatar.Image src={viewer.avatarUrl} alt={viewer.name} />}
              <Avatar.Fallback>{initials(viewer.name)}</Avatar.Fallback>
            </Avatar>
          ))}
          {overflow > 0 && <Avatar.GroupCount>+{overflow}</Avatar.GroupCount>}
        </Avatar.Group>
      </Tooltip.Trigger>
      <Tooltip.Content>{others.map(viewer => viewer.name).join(", ")}</Tooltip.Content>
    </Tooltip>
  );
};
